exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".browseideaspage-cssmodule-browseideaspage-component-GkWQ6{padding-bottom:10px;border:none}.browseideaspage-cssmodule-browseideaspage-nav-tab-1XlYB{padding-top:15px}", ""]);

// exports
exports.locals = {
	"browseideaspage-component": "browseideaspage-cssmodule-browseideaspage-component-GkWQ6",
	"browseideaspage-nav-tab": "browseideaspage-cssmodule-browseideaspage-nav-tab-1XlYB"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/BrowseIdeas/browseideaspage.cssmodule.scss
// module id = 597
// module chunks = 0